import { render, staticRenderFns } from "./forum_list.vue?vue&type=template&id=5d9b661f&scoped=true&"
import script from "./forum_list.vue?vue&type=script&lang=js&"
export * from "./forum_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9b661f",
  null
  
)

export default component.exports